import * as $ from 'jquery';
import { string2buffer, bufferEncode, coerceToArrayBuffer, coercebase64, coerceToBase64Url } from "./utility"
var base64js = require('base64-js');

type showerror = (msg: string, error?) => void;

export async function webAuthnLogin(makeAssertionOptions, showErrorAlert: showerror): Promise<boolean> {
    const makeAssertionCopy = JSON.parse(JSON.stringify(makeAssertionOptions));
    makeAssertionCopy.challenge = coercebase64(makeAssertionCopy.challenge);
    makeAssertionCopy.allowCredentials.forEach(function (listItem) {
        listItem.id = coercebase64(listItem.id);
    });

    console.log("Assertion options", makeAssertionCopy);
    let credential;
    try {
        credential = await navigator.credentials.get({ publicKey: makeAssertionCopy })
    } catch (err) {
        showErrorAlert(err.message ? err.message : err);
        return false;
    }
    console.log("Need to verify with server");
    var result = await webAuthnVerify(credential, showErrorAlert);
    return result;
}

async function webAuthnVerify(assertedCredential, showErrorAlert: showerror): Promise<boolean> {
    const authData = new Uint8Array(assertedCredential.response.authenticatorData);
    const clientDataJSON = new Uint8Array(assertedCredential.response.clientDataJSON);
    const rawId = new Uint8Array(assertedCredential.rawId);
    const sig = new Uint8Array(assertedCredential.response.signature);
    const data = {
        id: assertedCredential.id,
        rawId: coerceToBase64Url(rawId),
        type: assertedCredential.type,
        extensions: assertedCredential.getClientExtensionResults(),
        response: {
            authenticatorData: coerceToBase64Url(authData),
            clientDataJson: coerceToBase64Url(clientDataJSON),
            signature: coerceToBase64Url(sig)
        }
    };

    let response;
    try {
        const res = await fetch("/services/webauthnverify.ashx", {
            method: 'POST', // or 'PUT'
            body: JSON.stringify(data), // data can be `string` or {object}!
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });

        response = await res.json();
        //console.log("Verification response:");
        //console.log(response);
    } catch (e) {
        showErrorAlert("Request to server failed", e);
        return false;
    }

    // show error
    if (response.status !== "ok") {
        console.log("Error doing assertion");
        console.log(response.errorMessage);
        showErrorAlert(response.errorMessage);
        return false;
    }

    return true;
}

export async function webAuthnRegister(makeCredentialOptions):Promise<Credential> {
    // ensure we can try again if necessary
    const makeCredentialCopy = JSON.parse(JSON.stringify(makeCredentialOptions));

    // Turn the challenge back into the accepted format of padded base64
    makeCredentialCopy.challenge = coerceToArrayBuffer(makeCredentialOptions.challenge);
    // Turn ID into a UInt8Array Buffer for some reason
    makeCredentialCopy.user.id = coerceToArrayBuffer(makeCredentialCopy.user.id);

    makeCredentialCopy.excludeCredentials = makeCredentialCopy.excludeCredentials.map((c) => {
        c.id = coerceToArrayBuffer(c.id);
        return c;
    });

    console.log("Credential Options Formatted");
    console.log(makeCredentialCopy);

    //fulloptions.user.id = base64url.decode(fulloptions.user.id);
    //fulloptions.challenge = base64url.decode(fulloptions.challenge);
    const cred = await navigator.credentials.create({
        publicKey: makeCredentialCopy,
    });

    return cred;
}

export async function webAuthnSave(newCredential): Promise<any> {
    const attestationObject = new Uint8Array(newCredential.response.attestationObject);
    const clientDataJSON = new Uint8Array(newCredential.response.clientDataJSON);
    const rawId = new Uint8Array(newCredential.rawId);

    const data = {
        id: newCredential.id,
        rawId: base64js.fromByteArray(rawId),
        type: newCredential.type,
        extensions: newCredential.getClientExtensionResults(),
        response: {
            AttestationObject: base64js.fromByteArray(attestationObject),
            clientDataJson: base64js.fromByteArray(clientDataJSON)
        }
    };

    // Set the hidden field to the credential ID so it's saved upon submission

    console.log("Sending:")
    console.log(data);
    const response = await fetch('/services/webauthnsave.ashx', {
        method: 'POST', // or 'PUT'
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    });

    if (response.ok) {
        const responseData = await response.json();
        const saveData = responseData.Result.User.name;
        console.log("Saving " + saveData);
        $("#authcred").val(saveData);

        return responseData;
    }
    else {
        return null;
    }
}